let inc = 0

export class UUID {
    _uuid

    constructor() {
    	this._uuid = ++inc
    }

    get() {
    	return this._uuid
    }
}